/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import applicationFormStyle from "../applicationFormStyle";

const powerOfAttorneyStyle = {
  ...applicationFormStyle,
  text: {
    textAlign: "left",
  },
  nextStepsHeading: {
    marginTop: "30px",
    "text-align": { xs: "center", lg: "left" },
  },
  imageCircleContainer: {
    overflow: "hidden",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    margin: "0 auto",
    width: "100px",
    height: "100px",
    padding: "36px",
    borderRadius: "50% !important",
    "& > img": {
      maxHeight: "100px",
    },
  },
  highlightBoxContainer: {
    padding: "1rem 0",
  },
  imgCircleContainer: {
    paddingTop: "1rem",
  },
  buttonSubText: {
    color: "primary.main",
    fontWeight: 500,
    textAlign: "center",
  },
  submitButtonContainer: {
    paddingTop: "1rem",
  },
};

export default powerOfAttorneyStyle;
